import { PriceValue } from '@secretescapes/cauldron';
import styled, {
  Scale,
  TypographyVariant,
  css,
  keyframes,
  typographyVariantProperties,
} from '@secretescapes/falcon';
import { type CommonStyledProps, mediaQuery } from '@utils/styles.utils';
import { PAGE_CONTAINER_WIDTH } from '../SalePageDesktop.utils';

const fadeInAnimation = keyframes`
  0% {
    opacity: 0;
    visibility: hidden;
  }
  1% {
    opacity: 0;
    visibility: visible;
  }
  100% {
    opacity: 1;
    visibility: visible;
  }
`;

const fadeOutAnimation = keyframes`
  0% {
    opacity: 1;
  }
  99% {
    opacity: 0;
  }
  100% {
    visibility: hidden;
    opacity: 0;
  }
`;

interface PricingCtaContainerProps extends CommonStyledProps {
  animationTrigger: boolean;
}

export const PricingCtaContainer = styled('div')<PricingCtaContainerProps>(
  ({ isMobile, animationTrigger }) => css`
    display: flex;
    align-items: center;
    gap: ${isMobile ? '' : Scale.l};
    width: ${isMobile ? '100%' : ''};
    justify-content: ${isMobile ? 'space-between' : ''};
    flex-direction: row;

    ${!isMobile &&
    css`
      animation: ${animationTrigger ? fadeInAnimation : fadeOutAnimation} ease 0.3s;
      animation-iteration-count: 1;
      animation-fill-mode: forwards;

      @media ${mediaQuery.tablet} {
        flex-direction: column;
        gap: ${Scale.xxs};
      }
    `}
  `
);

export const Container = styled('div')<CommonStyledProps>(
  ({ isMobile, theme }) => css`
    width: ${isMobile ? '100%' : `${PAGE_CONTAINER_WIDTH}px`};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    background-color: ${theme.color.white};
    padding: ${isMobile ? Scale.m : ''};

    ${!isMobile &&
    css`
      @media ${mediaQuery.tablet} {
        padding: 0 ${Scale.m};
        align-items: flex-end;
      }
    `}
  `
);

export const StyledPriceValue = styled(PriceValue)`
  animation: ${fadeInAnimation} ease 0.3s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;

  span[data-testid='price-display-lead-rate'] {
    font-size: ${typographyVariantProperties[TypographyVariant.t4SansBold].tabletFontSize};
  }
`;
